module.exports = __webpack_public_path__ + "static/media/clutchLogin.1733f784.webp";